module.exports = __webpack_public_path__ + "img/icon_centralizacao_de_comunicacoes.3b2e0d95.svg";